import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"

Vue.use(Vuex)

var maxStorageHours = 24
if ( process.env.VUE_APP_MAX_STORAGE_HOURS ) {
  maxStorageHours = parseFloat(process.env.VUE_APP_MAX_STORAGE_HOURS)
}

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

const defaultState = {
  step: 1,
  reservation: {
    id: null,
    pickupDateTime: null,
    returnDateTime: null,
    location: null,
    returnLocation: null,
    flight: {
      flightNumber: null,
      arrivalDateTime: null
    },
    customLocation: null,
    car: null,
    discountCode: null,
    additionalCharges: null,
    availableAdditionalCharges: null,
    additionalChargesPrices: null,
    contact: null,
    agreeWithTerms: false,
    termsLink: "",
    basePath: "/",
    errors: [],
    reset: false,
    startDateTime: null,
    lastMutationDateTime: null,
  },
  dates: {
    pickupDate: null,
    pickupTime: null,
    returnDate: null,
    returnTime: null
  },
  type: "Car",
  prereservationType: "Car",
  bookNowUrl: "/book-now"
};

export default new Vuex.Store({
  state: defaultState,
  getters: {
    step: state => {
      return state.step;
    },
    reservation: state => {
      return state.reservation;
    },
    dates: state => {
      return state.dates;
    },
    type: state => {
      return window.reservationConfiguration.type;
    },
    prereservationType: state => {
      return state.prereservationType;
    },
    bookNowUrl: state => {
      return state.bookNowUrl;
    }
  },
  mutations: {
    checkState(state) {
      if (state.reservation.startDateTime) {
        var dateTimeNow = new Date()
        var differenceInHours = (dateTimeNow - state.reservation.startDateTime) / (1000*60*60)
        if ( differenceInHours > maxStorageHours ) {    
          state.reservation.reset = true
        }
      }
    },
    reset(state) {
      Object.assign(state, defaultState)
    },
    step(state, step) {
      state.step = step
      state.reservation.lastMutationDateTime = (new Date()).getTime()
      if ( !state.reservation.startDateTime ) {
        state.reservation.startDateTime = state.reservation.lastMutationDateTime
      }
    },
    reservation(state, reservation) {
      state.reservation = reservation
    },
    dates(state, dates) {
      state.dates = dates
    },
    setPickupDate(state, pickUpDate) {
      state.dates.pickupDate = pickUpDate
    },
    setPickupTime(state, pickUpTime) {
      state.dates.pickupTime = pickUpTime
    },
    setReturnDate(state, returnDate) {
      state.dates.returnDate = returnDate
    },
    setReturnTime(state, returnTime) {
      state.dates.returnTime = returnTime
    },
    setReservationId(state, id) {
      state.reservation.id = id
    },
    setType(state) {
      if ( window.reservationConfiguration ) {
        state.type = window.reservationConfiguration.type
      }
    },
    setBookNowUrl(state) {
      if ( window.reservationConfiguration ) {
        state.bookNowUrl = window.reservationConfiguration.bookNowUrl
      }
    },
    setPrereservationType(state) {
      if ( window.preReservationConfiguration ) {
        state.prereservationType = window.preReservationConfiguration.type
      }
    }
  },
  actions: {
    setType ({ commit }) {
      commit('setType')
    },
    setBookNowUrl ({ commit }) {
      commit('setBookNowUrl')
    },
    setPrereservationType ({ commit }) {
      commit('setPrereservationType')
    }
  },
  plugins: [vuexLocal.plugin]
});
